export default __webpack_public_path__ + "static/media/uniqshowhour.60b7d245.svg";